export function numberWithCommas(x, defaultValue = 'n/a') {
  if (x == null) return defaultValue
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}